export const COL_EXPENSE_IMPORT_MONTHS = "expense_import_months";
export const EXPENSE_IMPORT_LINE_CHUNKS_SUB = "lineChunks";
export const EXPENSE_CHUNK_CATEGORY = "expenses";
export const EXPENSE_WEEKS_PER_MONTH = 5;
export const EXPENSE_CHUNK_TARGET_BYTES = 700000;
export const EXPENSE_CHUNK_MAX_ROWS = 2500;
export const BATCH_WRITE_SIZE = 450;

/** Weekly expense slice in lineChunks, e.g. expenses_w3 */
export function expenseWeekCategory(weekOfMonth) {
  return `expenses_w${Number(weekOfMonth)}`;
}

export function isExpenseImportCategory(category) {
  const c = String(category || "");
  return c === EXPENSE_CHUNK_CATEGORY || /^expenses_w[1-5]$/.test(c);
}

export const COL_EXPENSE_BRANCH_TRANSFER_JOURNALS = "expense_branch_transfer_journals";

export const EXPECTED_EXPENSE_COLUMNS = [
  "Branch ID",
  "Voucher Type Name",
  "Voucher No",
  "Tran Date",
  "Party Name",
  "Transaction Type",
  "Amount",
];

/** Canonical party labels (fixed — not user-editable). */
export const PARTY_WINS_BRANCH_SDEBTOR = "WINS BRANCH (S.DEBTOR)";
export const PARTY_WINS_AUTOS_MAIN = "WINS AUTOS MAIN";

/** WINS BRANCH (S.DEBTOR) ledger opening balance per financial year (keyed by FY start year). */
export const WINS_BRANCH_SDEBTOR_OPENING_BALANCES = {
  2025: 7366452.56, // FY 2025-26 (closing 12,604,007.48)
  2026: 12604007.48, // FY 2026-27
};

export function winsBranchSDebtorOpeningBalance(fyStartYear) {
  return WINS_BRANCH_SDEBTOR_OPENING_BALANCES[Number(fyStartYear)] ?? 0;
}

/** SPARE WAY AUTO LINK ledger opening balance per financial year (Main Branch). */
export const SPARE_WAY_AUTO_LINK_OPENING_BALANCES = {
  2025: 3278203.60, // FY 2025-26
  2026: 4421339.89, // FY 2026-27
};

export function spareWayAutoLinkOpeningBalance(fyStartYear) {
  return SPARE_WAY_AUTO_LINK_OPENING_BALANCES[Number(fyStartYear)] ?? 0;
}

export const VOUCHER_TRANSFER_OUT_NEW = "Transfer Out - New";
export const VOUCHER_TRANSFER_IN = "Transfer IN";
export const VOUCHER_RECEIPT = "Receipt";
export const VOUCHER_JOURNAL = "Journal";

/**
 * Expense rows excluded from all reports (bad/duplicate uploads).
 * Each entry: voucherNo, party (substring), voucherType (substring), tranDate (YYYY-MM-DD or DD-MM-YYYY).
 */
export const EXPENSE_IMPORT_EXCLUDED_ROWS = [
  {
    voucherNo: "7065",
    party: "SPARE WAY AUTO LINK",
    voucherType: "CREDIT NOTE",
    tranDate: "2025-11-18",
  },
];

function normExpensePartyKey(name) {
  return String(name || "")
    .toUpperCase()
    .replace(/\s+/g, " ")
    .trim();
}

function normExpenseTranDateKey(d) {
  const s = String(d || "").trim();
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}`;
  const dmy = s.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
  if (dmy) {
    const dd = String(dmy[1]).padStart(2, "0");
    const mm = String(dmy[2]).padStart(2, "0");
    return `${dmy[3]}-${mm}-${dd}`;
  }
  return s;
}

/** True if this expense import row is on the exclusion list. */
export function isExcludedExpenseImportRow(row) {
  const vno = String(row?.voucherNo ?? "").trim();
  const party = normExpensePartyKey(row?.partyName);
  const vtype = String(row?.voucherTypeName ?? row?.voucherType ?? "")
    .toUpperCase()
    .trim();
  const tdate = normExpenseTranDateKey(row?.tranDate);

  return EXPENSE_IMPORT_EXCLUDED_ROWS.some((ex) => {
    if (String(ex.voucherNo).trim() !== vno) return false;
    if (!party.includes(normExpensePartyKey(ex.party))) return false;
    if (!vtype.includes(String(ex.voucherType || "").toUpperCase().trim())) return false;
    if (normExpenseTranDateKey(ex.tranDate) !== tdate) return false;
    return true;
  });
}
